import { useEffect } from 'react';

const STRUCTURED_DATA_ID = 'seo-checker-structured-data';

// 公開LP用のJSON-LD（WebApplication + Organization）。
// SPAのためビルド時の静的HTMLには含められず、マウント時にheadへ注入する。
// Googlebotはレンダリング後のDOMを評価するため、クロール自体には支障がない。
const STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebApplication',
      name: 'SEOチェッカー',
      url: 'https://seo.first-temple.co.jp/',
      description:
        'Google Search Central公式ガイド準拠の基準で、テクニカルSEO・Core Web Vitals・コンテンツ品質・構造化データを自動チェックする無料SEO診断ツール。',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'All',
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'JPY',
      },
      provider: {
        '@type': 'Organization',
        name: '株式会社ファーストテンプル',
        url: 'https://first-temple.co.jp/',
      },
    },
    {
      '@type': 'Organization',
      name: '株式会社ファーストテンプル',
      url: 'https://first-temple.co.jp/',
    },
  ],
};

/** 公開LP(/)マウント時にJSON-LDをheadへ注入し、アンマウント時に除去する。 */
export function useStructuredData() {
  useEffect(() => {
    let script = document.getElementById(STRUCTURED_DATA_ID) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = STRUCTURED_DATA_ID;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(STRUCTURED_DATA);

    return () => {
      script?.remove();
    };
  }, []);
}
